import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

import { Flexbox } from "../../core/components";

export const PaneContainer = styled(Flexbox)`
    position: relative;
    align-items: center;
`;

export const title = css`
    ${Fonts.Heading.H300};
    margin-bottom: 0;
`;

export const lensSourceButtonStyle = css`
    .icon-down {
        color: ${Colors.WHITE};
    }

    &.sds-base-button.ant-btn.primary {
        height: 32px;
    }
`;
